const EmployeeSkills = [
  "Plumbing",
  "HVAC",
  "Electrical",
  "Appliance Repair",
  "Solar systems",
  "Water systems",
  "Wiring",
  "General Maintenance",
];

export default EmployeeSkills;
